// =============================================================================
// Shared behaviour for the site's full-screen overlays: the mobile navigation
// drawer and the search panel.
//
// Both lock page scrolling while open and both close on Escape. Keeping those
// two pieces here rather than in each module is what stops them interfering:
// the search button stays reachable while the drawer is open, so a visitor can
// have both up at once, and whichever closes first must not unlock the page
// underneath the other.
// =============================================================================

let locks = 0;

/** Take the page scroll lock. Paired one-for-one with `releaseScroll()`. */
export function lockScroll() {
	locks += 1;
	if (locks === 1) {
		document.body.style.overflow = "hidden";
	}
}

/**
 * Give up one scroll lock.
 *
 * Floored at zero so an unmatched release — a module closing an overlay that
 * was never open — cannot drive the count negative and permanently lock the
 * page.
 */
export function releaseScroll() {
	locks = Math.max(0, locks - 1);
	if (locks === 0) {
		document.body.style.overflow = "";
	}
}

const escapers = new Set();

/**
 * Register a handler to run when Escape is pressed.
 *
 * One document-level listener serves every overlay, matching the design's
// single Escape-closes-everything behaviour. Handlers must be idempotent —
 * closing an overlay that is already closed has to be a no-op, including its
 * scroll-lock release — because Escape runs all of them.
 *
 * The listener is attached on the first registration, so a page with no
 * overlays never pays for one.
 */
export function closeOnEscape(handler) {
	if (escapers.size === 0) {
		document.addEventListener("keydown", (event) => {
			if (event.key !== "Escape") {
				return;
			}
			escapers.forEach((close) => close());
		});
	}

	escapers.add(handler);
}
